(function () {
  'use strict';

  var overlay  = document.getElementById('lumi-filters-overlay');
  var backdrop = document.querySelector('[data-filters-backdrop]');

  function openFilters() {
    if (!overlay) return;
    overlay.classList.add('is-open');
    overlay.setAttribute('aria-hidden', 'false');
    if (backdrop) backdrop.classList.add('is-visible');
    document.body.style.overflow = 'hidden';
  }

  function closeFilters() {
    if (!overlay) return;
    overlay.classList.remove('is-open');
    overlay.setAttribute('aria-hidden', 'true');
    if (backdrop) backdrop.classList.remove('is-visible');
    document.body.style.overflow = '';
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-filters-toggle]')) { openFilters(); return; }
    if (e.target.closest('[data-filters-close]') || e.target.closest('[data-filters-backdrop]')) { closeFilters(); }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeFilters();
  });
})();
